import React from 'react'
import { Typography } from '@mui/material'
import useFilterContext from 'components/Filter/context'
import useFavurTranslation from 'hooks/useFavurTranslation'
import FilterButton from 'redesign/components/atoms/Buttons/FilterButton'
import { AddIcon } from 'redesign/components/atoms/Icon'
import SubheaderFilters from 'redesign/components/molecules/TabBar/SubheaderFilters'
import Header from 'redesign/components/organisms/Header'
import { ONE } from 'shared/constants'
import FlexContainer from '../../../atoms/wrappers/flex-container'
import { HEADER_BUTTON_ANCHOR_ORIGIN, HEADER_BUTTON_TRANSFORM_ORIGIN } from '../../action-wrapper/constants'
import MoreButton from '../../more-button'
import type { TaskListHeaderProps } from './types'

const TaskListHeader: React.FC<TaskListHeaderProps> = ({
  isOffice,
  showAddTaskButton = false,
  moreButtonOptions = [],
}) => {
  const { t } = useFavurTranslation()
  const headerTitle = t(isOffice ? 'page.tasks.page.adminTitle' : 'page.tasks.page.title')
  const { openFilterPage } = useFilterContext()

  return (
    <Header
      middleContent={<Typography variant="subtitle1">{headerTitle}</Typography>}
      endContent={
        <FlexContainer gap={ONE}>
          {showAddTaskButton && (
            <MoreButton
              anchorOrigin={HEADER_BUTTON_ANCHOR_ORIGIN}
              transformOrigin={HEADER_BUTTON_TRANSFORM_ORIGIN}
              hiddenActions={moreButtonOptions}
              icon={AddIcon}
              topMenuMargin={ONE}
            />
          )}
          <FilterButton onClick={openFilterPage} />
        </FlexContainer>
      }
      subheader={<SubheaderFilters />}
    />
  )
}

export default TaskListHeader
